/*
 * AUTO-GENERATED FILE. DO NOT MODIFY
 *
 * This file was automatically generated by the
 * npm run generate-design-token command, and it
 * should not be modified by hand.
 */

export const SegmentedControlItemBaseSizeSmallHeight = '32px'
export const SegmentedControlItemBaseSizeMediumHeight = '40px'
export const SegmentedControlItemBaseSizeLargeHeight = '48px'
export const SegmentedControlItemBaseBorderRadiusLarge = '6px'
export const SegmentedControlItemBaseBorderRadiusMedium = '5px'
export const SegmentedControlItemBaseBorderRadiusSmall = '4px'
export const SegmentedControlItemBaseSpacingSmallPadding = '4px'
export const SegmentedControlItemBaseSpacingSmallGap = '0px'
export const SegmentedControlItemBaseSpacingSmallPaddingText = '0 4'
export const SegmentedControlItemBaseSpacingMediumPadding = '8px'
export const SegmentedControlItemBaseSpacingMediumGap = '4px'
export const SegmentedControlItemBaseSpacingMediumPaddingText = '0 4'
export const SegmentedControlItemBaseSpacingLargePadding = '12px'
export const SegmentedControlItemBaseSpacingLargeGap = '8px'
export const SegmentedControlItemBaseSpacingLargePaddingText = '0 4'
export const SegmentedControlItemColorDefaultBackground = '#ffffff00'
export const SegmentedControlItemColorDefaultOnBackground = '#00000099'
export const SegmentedControlItemColorDefaultOutline = '#ffffff00'
export const SegmentedControlItemColorHoveredBackground = '#f3f3f3'
export const SegmentedControlItemColorHoveredOnBackground = '#00000099'
export const SegmentedControlItemColorHoveredOutline = '#ffffff00'
export const SegmentedControlItemColorPressedBackground = '#ffede0'
export const SegmentedControlItemColorPressedOnBackground = '#ED9341'
export const SegmentedControlItemColorPressedOutline = '#ffffff00'
export const SegmentedControlItemColorDisabledBackground = '#ffffff00'
export const SegmentedControlItemColorDisabledOnBackground = '#00000061'
export const SegmentedControlItemColorDisabledOutline = '#ffffff00'
